export default __webpack_public_path__ + "static/media/sport.620b7387.svg";